<template>
    <div class="StoreInfo">
        <navigation-bar Back Bell :name="vendorInfo.name"/>
        <div class="main">
            <div class="container">
                <div class="shadow-box">

                    <banner :list="storeImgAry" :store="Number(1)"/>

                    <div class="card-body">
                        <div class="list-style border-0 pb-0 pt-0">
                            <div class="content">
                                <div class="phone-btn" v-show="isShowPhone()">
                                    <a @click="onClickCallBtn(vendorInfo.phone)" >
                                        <img src="@/assets/images/phone.svg">
                                        <span>{{vendorInfo.phone}}</span>
                                    </a>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>
                <div class="d-flex mt-2">
                    <!--todo FB、IG、YT等連結-->
                    <links :socialWebsites="websites" :socialWebsitesStatus="vendorInfo.websiteStatus" :iconType="iconType" isFlat v-if="vendorInfo.websiteStatus"/>
                </div>

                <div class="about mt-4" v-show="vendorInfo.aboutStatus">
                    <category-header title="關於我們" class="ml-0 mb-2"/>
                    <div>
                        <div class="text-content" v-if="aboutOpen" v-html="vendorInfo.about"/>
                        <div class="text-content" v-else v-html="vendorInfo.about.substring(0, 45) + '...'"/>

                        <div :class="aboutOpen?'read-more-close':'read-more'"
                             @click="[aboutOpen=!aboutOpen, sendClickFuncGAEvent('click_攤販關於我們')]">
                            <template v-if="aboutOpen">向上收合</template>
                            <template v-else>繼續閱讀</template>
                        </div>
                    </div>
                </div>

                <div class="about mt-4" v-show="isShowVideo(videoUrl)">
                    <div class="video-container">
                        <iframe id="store-video-frame" width="560" height="315" src="" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>
                    </div>
                </div>
            </div>
            <category-content v-show="isShowPhoto()">
                <category-header title="PHOTOS"/>
                <item-grid>
                    <vue-preview :slides="photoArray"/>
                </item-grid>
            </category-content>
        </div>

        <loading
            :active.sync=isLoading
            :can-cancel="false"
            :is-full-page="true">
        </loading>

    </div>
</template>

<script>
    import CategoryContent from '@/components/category/Content.vue';
    import CategoryHeader from '@/components/category/Header.vue';
    import ItemGrid from '@/components/category/ItemGrid.vue';
    import Banner from '@/components/BannerSlider.vue';
    import Links from "../../views/complex/components/Links";
    import * as constDefine from "@/store/constDefine";
    import * as mutationTypes from "@/store/mutationTypes";
    import Analytics from "@/util/analytics";
    export default {
        name: "StallInfo",
        components: {
            CategoryContent,
            CategoryHeader,
            ItemGrid,
            Banner,
            Links,
        },
        data() {
            return {
                isLoading: false,
                dataToken: this.$route.query.dataToken !== undefined ? this.$route.query.dataToken : "",
                dataObject: {},
                vendorInfo: {
                    aboutStatus: 0,
                    about:"",
                    id:0 ,
                    logoImageUrl: "",
                    media_url: "",
                    name: "",
                    phone: "",
                    photoImageUrlAry: [],
                    websites: '',
                    websiteStatus: false,
                },
                iconType: 'isFlat', //社群連結Icon樣式
                storeImgAry: [],
                videoUrl: '',
                aboutOpen: false,       //關於我們看更多
                aboutText: '',         //關於我們轉純文字字串
                photoArray: [],         //菜單放大圖用
                //店家網頁連結
                mediaLinks: {
                    linkFb: '',
                    linkIg: '',
                    linkLine: '',
                    linkYoutube: '',
                    linkWebsite: '',
                    linkTwitter: '',
                    linkTiktok: '',
                    linkFoodpanda: '',
                    linkUbereats: '',
                },
                websites: '',
                websiteStatus: false,

                analytics: null,
            }
        },
        created() {
            this.analytics = Analytics.getInstance(this.$route, this.$route.name);
        },
        mounted() {

            if (this.dataToken !== "") {
                this.initForDataToken(this.dataToken);
            }

        },
        methods: {

            initForDataToken(item) {
                let self = this;
                try {
                    this.dataObject = this.$crypto.uriComponentToObject(item);
                    if (this.$public.notNull(this.dataObject?.id)) {
                        this.getVendorInfoByIdApi(this.dataObject.id)
                            // .then( data => {
                            //
                            // })
                            .catch( (error) => {
                                self.$store.commit(mutationTypes.SHOW_TOAST, '無法取得商店資訊');
                            });
                    }

                } catch (e) {
                    this.$router.push({name: 'Error'});
                    return false;
                }
            },

            /** 呼叫 取得攤販資訊api */
            getVendorInfoByIdApi (vendorId) {

                let self = this;
                self.isLoading = true;

                //取得店家資訊
                return new Promise(function(resolve, reject) {
                    self.$http.fetch`GetVendorInfo${{
                        vendorId: vendorId,
                    }} ${json => {
                        self.isLoading = false;
                        if (self.$public.notNull(json.data)) {
                            self.vendorInfo = json.data;

                            //關於我們
                            self.about = self.vendorInfo.about;

                            //社群連結
                            self.websites = JSON.stringify(json.data.websites)==='[]'?'[]':JSON.stringify(json.data.websites)===''?'':typeof json.data.websites==="object"?json.data.websites.length>0?JSON.stringify(json.data.websites):'':'';
                            if (self.$public.notNull(self.vendorInfo?.websites) &&
                                self.vendorInfo?.websites.length > 0) {

                                self.vendorInfo.websites.forEach(
                                    (item) => {
                                        switch (item.type) {
                                            case constDefine.SITE_TYPE_FB:
                                                self.mediaLinks.linkFb = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_IG:
                                                self.mediaLinks.linkIg = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_LINE:
                                                self.mediaLinks.linkLine = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_YOUTUBE:
                                                self.mediaLinks.linkYoutube = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_WEBSITE:
                                                self.mediaLinks.linkWebsite = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_TWITTER:
                                                self.mediaLinks.linkTwitter = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_TIKTOK:
                                                self.mediaLinks.linkTiktok = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_FOODPANDA:
                                                self.mediaLinks.linkFoodpanda = item.url;
                                                break;
                                            case constDefine.SITE_TYPE_UBEREATS:
                                                self.mediaLinks.linkUbereats = item.url;
                                                break;
                                        }
                                    }
                                )
                            }

                            //影片
                            self.changeVideoUrl(self.vendorInfo.mediaUrl);

                            //菜單和放大圖使用
                            if (self.$public.notNull(self.vendorInfo.photoImageUrlAry)) {
                                self.vendorInfo.photoImageUrlAry.forEach(function (item, index) {
                                    const newImg = new Image();
                                    newImg.onload = () => {
                                        self.photoArray.push(
                                            {
                                                src: item.path,          //大圖
                                                msrc: item.path,         //小圖
                                                w: newImg.width,    //抓圖片原始的寬
                                                h: newImg.height,   //抓圖片原始的高
                                            }
                                        );
                                    }
                                    newImg.src = item.path;
                                });
                            }

                            if (self.$public.notNull(self.vendorInfo?.logoImageUrl) && self.vendorInfo?.logoImageUrl !== "") {
                                //轉換成 BannerSlider 可以用的格式
                                self.storeImgAry.push({
                                        url: '',
                                        imgUrl: self.vendorInfo.logoImageUrl,
                                    });
                            }

                            resolve();

                        } else {
                            reject(`GetStoreInfoById: 無法取得資料`);
                        }
                    }}`;
                });

            },

            /** 開啓 url */
            onLinkClick: function (url) {
                let isCordova = !!window.cordova;
                if (isCordova) {
                    //開啓頁面
                    this.$public.openUrl(url);
                } else {
                    window.open(url);
                }
            },

            /** 是否顯示電話 */
            isShowPhone: function () {
                return (this.$public.notNull(this.vendorInfo?.phone) && this.vendorInfo?.phone !== "")
            },

            /** 點擊電話按鈕 */
            onClickCallBtn: function (tel) {
                this.analytics.sendEvent(Analytics.EVENTS.MAKE_A_CALL);
                this.$public.callTel(tel);
            },

            /** 是否顯示關於我們 */
            isShowAbout: function () {
                return (this.$public.notNull(this.vendorInfo?.about) && this.vendorInfo?.about !== "")
            },

            /** 是否顯示照片 */
            isShowPhoto: function () {
                return (this.$public.notNull(this.vendorInfo?.photoImageUrlAry) && this.vendorInfo?.photoImageUrlAry.length > 0)
            },

            /** 是否顯示影片 url */
            isShowVideo: function (videoUrl) {
                return (this.$public.notNull(videoUrl) && videoUrl !== "")
            },

            /** 替換影片 url */
            changeVideoUrl: function (url) {
                //替換 i-frame 的連結
                // let watchKey = 'watch?v=';
                // let video = 'https://www.youtube.com/embed/69arSuOXsRE?controls=0';
                // this.videoUrl = 'https://www.youtube.com/watch?v=v_RT8hLUDuo';
                // this.videoUrl = '<iframe width="560" height="315" src="'+ video +'" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"/>';

                if (this.$public.notNull(url) && url !== "") {
                    this.videoUrl = this.$public.getEmbedVideoUrl(url);
                    let frame = document.getElementById('store-video-frame');
                    if (this.$public.notNull(frame)) {
                        frame.src = this.videoUrl;
                    }
                }
            },

            /** 發出點擊功能鈕的 GA事件 */
            sendClickFuncGAEvent: function (eventName) {
                if (this.$public.notNull(this.vendorInfo)) {
                    let eventTitle = this.$public.getClearStrRegExp(`${eventName}_${this.vendorInfo.name}`.replace(/ /g, ""));
                    this.$public.addGAEventLog(eventTitle, {vendor_name: this.vendorInfo.name.replace(/ /g, "")});
                } else {
                    this.$public.addGAEventLog(`${eventName.replace(/ /g, "")}`, {vendor_name: ""});
                }
            },
        },
    }
</script>

<style lang="less" scoped src="../../less/store.less"/>
<style lang="less" scoped>
    /deep/.read-more{
        display: block;
    }
</style>